<div class="ai-follow-ups">
  <button
    type="button"
    *ngFor="let question of block.questions"
    (click)="followUpSelected.emit(question.query)"
  >
    {{ question.label }}
  </button>
</div>
